import { render, staticRenderFns } from "./add-fba-shipment-modal.vue?vue&type=template&id=0d84082b&scoped=true&"
import script from "./add-fba-shipment-modal.vue?vue&type=script&lang=js&"
export * from "./add-fba-shipment-modal.vue?vue&type=script&lang=js&"
import style0 from "./add-fba-shipment-modal.vue?vue&type=style&index=0&id=0d84082b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84082b",
  null
  
)

export default component.exports